export default {"src":"/_next/static/media/verified.ba9bd380.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};